import React from "react";
import axisbank from "../../../assets/images/bankImages/axis-bank-logo 1.png";
import IDBI from "../../../assets/images/bankImages/IDBI-Bank.png";
import IndusInd from "../../../assets/images/bankImages/IndusIndBank.png";
import Idfc from "../../../assets/images/bankImages/IDFCBank.png";
import qwBank from "../../../assets/images/bankImages/qwBank.png";
import bajaj from "../../../assets/images/bankImages/bajaj.png"
import  { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

function Partners() {
  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration in milliseconds
      once: false,
      offset: 100,  // Trigger when the element is 100px from the viewport
  delay: 200, // Whether animation should happen only once
    });
  }, []);
  return (
    <div className="pt-12" id="partners">
      <h1
        className="xl:text-5xl md:text-4xl text-2xl font-bold text-center text-blue-900 mb-6 oxygen px-7 sm:px-0"
        data-aos="fade-up"
      >
        Our Trusted banks !
      </h1>
      <p
        className="text-center text-[#868686] md:max-w-[65%] md:mx-auto mb-10 mx-6 md:text-lg oxygen text-sm"
        data-aos="fade-up"
      >
        Our trusted partners are esteemed organizations and individuals who
        collaborate with us to deliver exceptional value and ensure the highest
        quality in our services and solutions."
      </p>
      <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-6 lg:grid-cols-6 gap-5 px-12">
        <div className="bg-[#E8F4FA] flex justify-center items-center" data-aos="fade-up">
          <img src={Idfc} alt="Professionally Managed" className="xl:p-12 lg:p-10 md:p-6 p-8"/>
        </div>
        <div className="bg-[#E8F4FA] flex justify-center items-center" data-aos="fade-down">
          <img src={qwBank} alt="Live Close" className="xl:p-9 lg:p-7 md:p-4 p-7"/>
        </div>
        <div className="bg-[#E8F4FA] flex justify-center items-center" data-aos="fade-up">
          <img src={axisbank} alt="No Brokerage" className="xl:p-9 lg:p-7 md:p-4 p-7 "/>
        </div>
        <div className="bg-[#E8F4FA] flex justify-center items-center" data-aos="fade-down">
          <img src={IDBI} alt="Housing Professionals" className="xl:p-9 lg:p-7 md:p-4 p-7"/>
        </div>
        <div className="bg-[#E8F4FA] flex justify-center items-center" data-aos="fade-up">
          <img src={IndusInd} alt="" className="xl:p-9 lg:p-7 md:p-4 p-7"/>
        </div>
        <div className="bg-[#E8F4FA] flex justify-center items-center" data-aos="fade-down">
          <img src={bajaj} alt="" className="xl:p-4 lg:p-3 md:p-2 p-4"/>
        </div>
      </div>
    </div>
  );
}

export default Partners;
